<template>
  <div class="pagination">
    <el-pagination background
      layout="total, prev, pager, next, jumper"
      :total="total"
      :current-page="now"
      :page-size="pageSize"
      @current-change="change">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: Number,
    now: {
      default: () => 1
    },
    pageSize: Number
  },

  methods: {
    change(val) {
      this.$emit('update:now', val)
    }
  }
}
</script>
<style lang="scss">
.pagination {
  padding-top: 10px;
  text-align: center;
}
</style>